export interface PropertiesState {
  isLoading: boolean | null;
};
export const initialState = {
  isLoading: null
};